module.exports = __webpack_public_path__ + "img/icon_map_61_on_101.e0556389.png";